<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Contractor data') }}</Tab>
                <Tab value="2">{{ __('Payments') }}</Tab>
                <Tab value="3">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="project_name"
                                       label="Project name"
                                       validation="required"
                                       size="8"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.project_name" />

                        <FormSelect fieldName="status_id"
                                    label="Status"
                                    size="4"
                                    :isFormDisabled="true"
                                    :options="select?.statuses"
                                    v-model:field="crud.status_id" />
                    </div>
                    <div class="grid">
                        <FormMultiselect fieldName="project_users"
                                         label="Users"
                                         size="4"
                                         :isFormDisabled="isFormDisabled"
                                         :options="select?.users"
                                         v-model:field="crud.project_users" />

                        <FormSelect fieldName="agreement_id"
                                    label="Agreement"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled || isAgreementDisabled"
                                    :options="select?.agreements"
                                    v-model:field="crud.agreement_id" />

                        <FormCalendar fieldName="start_date"
                                      label="Start date"
                                      size="2"
                                      validation="required"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.start_date" />

                        <FormCalendar fieldName="end_date"
                                      label="End date"
                                      size="2"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.end_date" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="contractor_id"
                                    label="Contractor"
                                    size="6"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.contractors"
                                    :change="(e) => changeContractorData(e)"
                                    v-model:field="crud.contractor_id" />

                        <FormSelect fieldName="trader_id"
                                    label="Trader"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.users"
                                    v-model:field="crud.trader_id" />

                        <FormSelect fieldName="creator_id"
                                    label="Creator"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.users"
                                    v-model:field="crud.creator_id" />

                        <FormInputNumber fieldName="budget"
                                         label="Budget"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.budget" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                </TabPanel>
                <TabPanel value="1">
                    <div class="grid">
                        <FormInputText fieldName="city"
                                       label="City"
                                       size="4"
                                       :isFormDisabled="true"
                                       :field="crud?.contractor?.city" />

                        <FormInputText fieldName="address"
                                       size="6"
                                       :isFormDisabled="true"
                                       :field="crud?.contractor?.address" />

                        <FormInputText fieldName="postal_code"
                                       label="Postal code"
                                       size="2"
                                       :isFormDisabled="true"
                                       :field="crud?.contractor?.postal_code" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="nip"
                                       label="NIP"
                                       size="3"
                                       :isFormDisabled="true"
                                       :field="crud?.contractor?.nip" />

                        <FormInputText fieldName="phone"
                                       label="Phone"
                                       size="3"
                                       :isFormDisabled="true"
                                       :field="crud?.contractor?.phone" />

                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="4"
                                       :isFormDisabled="true"
                                       :field="crud?.contractor?.email" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="true"
                                    :field="crud?.contractor?.description" />
                    </div>
                </TabPanel>

                <TabPanel value="2">
                    <div class="grid">
                        <FormRepeaterTable v-model:record="crud.project_statements"
                                           :keys="{ 'operation_date': null, 'contractor_name': null, 'transfer_title': null, 'amount': null }"
                                           :isFirstRowEmpty="false"
                                           :isCopyButton="false"
                                           :isAddButton="false"
                                           repeaterStyle="margin-top:5px;width:95%"
                                           name="project_statements"
                                           :title="[__('Date'), __('Contractor name'), __('Transfer title'), __('Amount')]">
                            <template #repeat="slotProps">
                                <td style="width:10%;"
                                    :style="slotProps.cellStyle">
                                    <FormCalendar fieldName="operation_date"
                                                  :inRepeater="true"
                                                  :isFormDisabled="true"
                                                  v-model:field="slotProps.record.operation_date" />
                                </td>
                                <td style="width:40%;"
                                    :style="slotProps.cellStyle">
                                    <FormInputText fieldName="contractor_name"
                                                   :inRepeater="true"
                                                   :isFormDisabled="true"
                                                   v-model:field="slotProps.record.contractor_name" />
                                </td>
                                <td style="width:40%;"
                                    :style="slotProps.cellStyle">
                                    <FormInputText fieldName="transfer_title"
                                                   :inRepeater="true"
                                                   :isFormDisabled="true"
                                                   v-model:field="slotProps.record.transfer_title" />
                                </td>
                                <td style="width:10%;"
                                    :style="slotProps.cellStyle">
                                    <FormInputNumber fieldName="amount"
                                                     :inRepeater="true"
                                                     :minFractionDigits="2"
                                                     :maxFractionDigits="2"
                                                     v-model:field="slotProps.record.amount" />
                                </td>
                            </template>
                        </FormRepeaterTable>
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="3"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-show="buttonProps">
                    <span class='alert-button-position'>
                        <CustomButton v-if="!formProps.addMode"
                                      name="projectStages"
                                      :click="() => goToStages()"
                                      :buttonProps="buttonProps"
                                      tooltip="Realizacja etapów"
                                      style="margin:0 5px"
                                      severity="success">
                            <i class="fa-solid fa-list-check"></i>
                        </CustomButton>
                    </span>
                </template>

                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'projects', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { router } from '@inertiajs/vue3'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import AlertAdd from '@alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import CustomButton from '@crud/CustomButton.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __, getStatusId, screenMessage, getStoreValue, currentDate, getFromRoute } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
    agreementData: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

const options = ["statuses", "agreements", "contractors", "users"];
const select = ref(null);
const isAgreementDisabled = ref(false);
const isAddAlertDialogOpen = ref(false);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select)

    if (props.formProps.addMode == true) {
        crud.value.creator_id = getStoreValue('myId');
        crud.value.status_id = await getStatusId('STA_PROJECT', 'SYM_REGISTERED');
        crud.value.start_date = currentDate();
        changeContractorData({ value: props.agreementData?.contractor_id || null })

        if (props.agreementData) {
            crud.value.agreement_id = props.agreementData.id
            crud.value.contractor_id = props.agreementData.contractor_id
            crud.value.trader_id = props.agreementData.trader_id
            crud.value.project_name = props.agreementData.agreement_name
            crud.value.budget = props.agreementData.budget
            crud.value.from_agreement_id = props.agreementData.id
        }
    }
    if (props.formProps.viewParams?.agreement_id) {
        crud.value.agreement_id = props.formProps.viewParams.agreement_id;
        isAgreementDisabled.value = true;
    }

})

// -----------------------------------------------------

const goToStages = () => {
    router.visit(route('project-stages-view', { projectId: crud.value.id, agreement_id: props.formProps.viewParams?.agreement_id ? true : false, backToView: false }), {
        onError: (errors) => {
            const message = errors?.error ?? 'Wystąpił nieznany błąd'
            screenMessage({ type: 'error', title: __('Error'), message: message });
        }
    })
}

// -----------------------------------------------------

const changeContractorData = async (e) => {
    const contractor = await getFromRoute('contractor-record', { 'id': e.value })
    crud.value.contractor = contractor ? contractor : null;
}

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
